// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"7ce2018a","142":"906010e7","190":"a344e0e4","287":"0cfaea20","374":"7169f81a","453":"48945080","785":"c7bc44db","790":"7619e67a"}[chunkId] + ".chunk.js";
};